import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'

import { Content } from './Content'

type Props = {
  locationToShare?: uui.domain.LatLng
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content locationToShare={props.locationToShare} />
    </Modal>
  )
}
